import '../../assets/index40.css';var ye = Object.defineProperty, Ce = Object.defineProperties;
var Ie = Object.getOwnPropertyDescriptors;
var E = Object.getOwnPropertySymbols;
var Q = Object.prototype.hasOwnProperty, X = Object.prototype.propertyIsEnumerable;
var K = (e, o, r) => o in e ? ye(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, i = (e, o) => {
  for (var r in o || (o = {}))
    Q.call(o, r) && K(e, r, o[r]);
  if (E)
    for (var r of E(o))
      X.call(o, r) && K(e, r, o[r]);
  return e;
}, C = (e, o) => Ce(e, Ie(o));
var b = (e, o) => {
  var r = {};
  for (var s in e)
    Q.call(e, s) && o.indexOf(s) < 0 && (r[s] = e[s]);
  if (e != null && E)
    for (var s of E(e))
      o.indexOf(s) < 0 && X.call(e, s) && (r[s] = e[s]);
  return r;
};
var Y = (e, o, r) => new Promise((s, u) => {
  var p = (a) => {
    try {
      w(r.next(a));
    } catch (h) {
      u(h);
    }
  }, d = (a) => {
    try {
      w(r.throw(a));
    } catch (h) {
      u(h);
    }
  }, w = (a) => a.done ? s(a.value) : Promise.resolve(a.value).then(p, d);
  w((r = r.apply(e, o)).next());
});
import { jsxs as re, jsx as t } from "react/jsx-runtime";
import { useState as R, useCallback as Pe, useEffect as se, forwardRef as De } from "react";
import { Label as Se } from "../Label/index.js";
import { ErrorMessage as _e } from "../../molecules/ErrorMessage/index.js";
import { CrosshairsFarFAIcon as ge } from "../Icons/index.js";
import { c as Z } from "../../get-size-Bc1Pz5yf.js";
import { c as ke } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as ze } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { u as Ee } from "../../use-styles-DToiHEa6.js";
import { f as be, u as Ne } from "../../factory-ueRxoNOV.js";
import { A as Re, c as L, p as T, i as N, C as Oe, a as Ve } from "../../ColorPicker-BjXFwAa-.js";
import { I as q } from "../../Input--FNE961U.js";
import { u as xe } from "../../use-input-props-TH9VAmBb.js";
import { I as Be } from "../../InputBase-Cabx1d9o.js";
import { P as j } from "../../Popover-COBqkLTt.js";
import { u as Ae } from "../../use-uncontrolled-BT_j5D2R.js";
import { u as He } from "../../use-isomorphic-effect-CiIycTKV.js";
import { u as Me } from "../../use-reduced-motion-C9DbPZfj.js";
import { B as Ge } from "../../Button-D50dlMrD.js";
function Le() {
  return navigator.userAgent.includes("OPR");
}
function Te() {
  const [e, o] = R(!1);
  He(() => {
    o(typeof window != "undefined" && !Le() && "EyeDropper" in window);
  }, []);
  const r = Pe(
    (s = {}) => e ? new window.EyeDropper().open(s) : Promise.resolve(void 0),
    [e]
  );
  return { supported: e, open: r };
}
function je(r) {
  var s = r, { style: e } = s, o = b(s, ["style"]);
  return /* @__PURE__ */ re(
    "svg",
    C(i({
      xmlns: "http://www.w3.org/2000/svg",
      style: i({
        width: "var(--ci-eye-dropper-icon-size)",
        height: "var(--ci-eye-dropper-icon-size)"
      }, e),
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, o), {
      children: [
        /* @__PURE__ */ t("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ t("path", { d: "M11 7l6 6" }),
        /* @__PURE__ */ t("path", { d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z" })
      ]
    })
  );
}
var ee = { eyeDropperIcon: "m_b077c2bc", colorPreview: "m_c5ccdcab", dropdown: "m_5ece2cd7" };
const oe = {
  format: "hex",
  fixOnBlur: !0,
  withPreview: !0,
  swatchesPerRow: 7,
  withPicker: !0,
  popoverProps: { transitionProps: { transition: "fade", duration: 0 } },
  withEyeDropper: !0
}, Fe = ke((e, { size: o }) => ({
  eyeDropperIcon: {
    "--ci-eye-dropper-icon-size": Z(o, "ci-eye-dropper-icon-size")
  },
  colorPreview: {
    "--ci-preview-size": Z(o, "ci-preview-size")
  }
})), F = be((e, o) => {
  const r = Ne("ColorInput", oe, e), J = xe("ColorInput", oe, e), {
    classNames: s,
    styles: u,
    unstyled: p,
    disallowInput: d,
    fixOnBlur: w,
    popoverProps: a,
    withPreview: h,
    withEyeDropper: W,
    eyeDropperIcon: S,
    closeOnColorSwatchClick: O,
    eyeDropperButtonProps: l,
    value: _,
    defaultValue: V,
    onChange: v,
    onChangeEnd: f,
    onClick: m,
    onFocus: x,
    onBlur: B,
    inputProps: A,
    format: P,
    wrapperProps: te,
    readOnly: H,
    withPicker: U,
    swatches: M,
    disabled: $,
    leftSection: ne,
    rightSection: ie,
    swatchesPerRow: ae
  } = J, pe = b(J, [
    "classNames",
    "styles",
    "unstyled",
    "disallowInput",
    "fixOnBlur",
    "popoverProps",
    "withPreview",
    "withEyeDropper",
    "eyeDropperIcon",
    "closeOnColorSwatchClick",
    "eyeDropperButtonProps",
    "value",
    "defaultValue",
    "onChange",
    "onChangeEnd",
    "onClick",
    "onFocus",
    "onBlur",
    "inputProps",
    "format",
    "wrapperProps",
    "readOnly",
    "withPicker",
    "swatches",
    "disabled",
    "leftSection",
    "rightSection",
    "swatchesPerRow"
  ]), G = Ee({
    name: "ColorInput",
    props: r,
    classes: ee,
    classNames: s,
    styles: u,
    unstyled: p,
    rootSelector: "wrapper",
    vars: r.vars,
    varsResolver: Fe
  }), { resolvedClassNames: g, resolvedStyles: k } = ze({
    classNames: s,
    styles: u,
    props: r
  }), [le, z] = R(!1), [ce, ue] = R(""), [c, D] = Ae({
    value: _,
    defaultValue: V,
    finalValue: "",
    onChange: v
  }), { supported: de, open: fe } = Te(), me = /* @__PURE__ */ t(
    Re,
    C(i(i({}, l), G("eyeDropperButton", {
      className: l == null ? void 0 : l.className,
      style: l == null ? void 0 : l.style
    })), {
      variant: "subtle",
      color: "gray",
      size: A.size,
      unstyled: p,
      onClick: () => fe().then((n) => {
        if (n != null && n.sRGBHex) {
          const y = L(P, T(n.sRGBHex));
          D(y), f == null || f(y);
        }
      }).catch(() => {
      }),
      children: S || /* @__PURE__ */ t(je, i({}, G("eyeDropperIcon")))
    })
  ), we = (n) => {
    x == null || x(n), z(!0);
  }, he = (n) => {
    w && D(ce), B == null || B(n), z(!1);
  }, ve = (n) => {
    m == null || m(n), z(!0);
  };
  return se(() => {
    (N(c) || c.trim() === "") && ue(c);
  }, [c]), Me(() => {
    N(c) && D(L(P, T(c)));
  }, [P]), /* @__PURE__ */ t(
    q.Wrapper,
    C(i({}, te), {
      classNames: g,
      styles: k,
      __staticSelector: "ColorInput",
      children: /* @__PURE__ */ re(
        j,
        C(i({
          __staticSelector: "ColorInput",
          position: "bottom-start",
          offset: 5,
          opened: le
        }, a), {
          classNames: g,
          styles: k,
          unstyled: p,
          withRoles: !1,
          disabled: H || U === !1 && (!Array.isArray(M) || M.length === 0),
          children: [
            /* @__PURE__ */ t(j.Target, { children: /* @__PURE__ */ t(
              q,
              C(i(i({
                autoComplete: "off"
              }, pe), A), {
                classNames: g,
                styles: k,
                disabled: $,
                ref: o,
                __staticSelector: "ColorInput",
                onFocus: we,
                onBlur: he,
                onClick: ve,
                spellCheck: !1,
                value: c,
                onChange: (n) => {
                  const y = n.currentTarget.value;
                  D(y), N(y) && (f == null || f(L(P, T(y))));
                },
                leftSection: ne || (h ? /* @__PURE__ */ t(
                  Oe,
                  i({
                    color: N(c) ? c : "#fff",
                    size: "var(--ci-preview-size)"
                  }, G("colorPreview"))
                ) : null),
                readOnly: d || H,
                pointer: d,
                unstyled: p,
                rightSection: ie || (W && !$ && !H && de ? me : null)
              })
            ) }),
            /* @__PURE__ */ t(
              j.Dropdown,
              {
                onMouseDown: (n) => n.preventDefault(),
                className: ee.dropdown,
                children: /* @__PURE__ */ t(
                  Ve,
                  {
                    __staticSelector: "ColorInput",
                    value: c,
                    onChange: D,
                    onChangeEnd: f,
                    format: P,
                    swatches: M,
                    swatchesPerRow: ae,
                    withPicker: U,
                    size: A.size,
                    focusable: !1,
                    unstyled: p,
                    styles: k,
                    classNames: g,
                    onColorSwatchClick: () => O && z(!1)
                  }
                )
              }
            )
          ]
        })
      )
    })
  );
});
F.classes = Be.classes;
F.displayName = "@mantine/core/ColorInput";
const We = "ColorPicker-module__root___bkeTE", Ue = "ColorPicker-module__wrapper___NoI-V", I = {
  root: We,
  wrapper: Ue
}, $e = De((W, h) => {
  var S = W, {
    "data-plum-id": e,
    label: o,
    description: r,
    error: s,
    required: u,
    onChange: p,
    value: d,
    defaultValue: w
  } = S, a = b(S, [
    "data-plum-id",
    "label",
    "description",
    "error",
    "required",
    "onChange",
    "value",
    "defaultValue"
  ]);
  const [O, l] = R(d || w || "");
  se(() => {
    d !== void 0 && l(d);
  }, [d]);
  const _ = (v) => {
    l(v), p && p(v);
  }, V = (v) => Y(void 0, null, function* () {
    if (v.preventDefault(), v.stopPropagation(), !window.EyeDropper) {
      console.log("EyeDropper not supported");
      return;
    }
    try {
      const m = yield new window.EyeDropper().open();
      m != null && m.sRGBHex && _(m.sRGBHex);
    } catch (f) {
      console.log("Eyedropper was cancelled");
    }
  });
  return /* @__PURE__ */ t(
    F,
    i({
      ref: h,
      "data-plum-id": e,
      classNames: {
        root: I.root,
        wrapper: I.wrapper,
        dropdown: I.dropdown,
        colorPreview: I.colorPreview,
        swatches: I.swatches,
        swatch: I.swatch
      },
      label: /* @__PURE__ */ t(Se, { label: o, withAsterisk: u }),
      description: r,
      error: s && /* @__PURE__ */ t(_e, { error: s }),
      inputWrapperOrder: ["label", "input", "description", "error"],
      rightSectionPointerEvents: "all",
      rightSection: /* @__PURE__ */ t(
        Ge,
        {
          variant: "tertiary",
          size: "sm",
          onClick: V,
          children: /* @__PURE__ */ t(ge, { size: 12 })
        }
      ),
      required: u,
      value: O,
      onChange: _
    }, a)
  );
});
$e.displayName = "ColorPicker";
export {
  $e as ColorPicker
};
